export function processSeoInput(input) {
  input.meta_title = input.meta_title ? input.meta_title : undefined
  input.meta_description = input.meta_description ? input.meta_description : undefined
  if (input.meta_tag && input.meta_tag.length > 0) {
    input.meta_tag = input.meta_tag.join(",")
  } else {
    input.meta_tag = undefined
  }
  return input
}